import { useState } from 'react';
import { Toast } from 'react-bootstrap';

function NotificationDisplay({ notificationText, close }) {
    const [show, setShow] = useState(true);
    return (
        <Toast onClose={() => { setShow(false); close()}} show={show} delay={3000} autohide position={"top-end"}>
            <Toast.Header closeButton={false}>
              <strong className="me-auto">Notification!</strong>
              <small>2 seconds ago</small>
            </Toast.Header>
            <Toast.Body>{ notificationText } </Toast.Body>
        </Toast>
    );
}

export default NotificationDisplay;